// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type CreateAttachmentRequest from '../contract/CreateAttachmentRequest';

export default function createAttachmentRequest(
    data: CreateAttachmentRequest
): CreateAttachmentRequest {
    const result: CreateAttachmentRequest = {
        __type: 'CreateAttachmentRequest:#Exchange',
        ...data,
    };

    return result;
}
